// Logos from Review Apps
import CapterraLogoSVG from '@/svg/review-app-logos/capterraLogo';
import CrowdLogoSVG from '@/svg/review-app-logos/crowdLogo';
import GetAppLogoSVG from '@/svg/review-app-logos/getAppLogo';
import SoftwareAdviceLogoSVG from '@/svg/review-app-logos/softwareAdviceLogo';
import RatingStarsSVG from '@/svg/rating-stars';
// Pricing
import CheckmarkSVG from '@/svg/pricing-icons/checkmark';
// Generic
import ArrowSVG from '@/svg/arrow';
import UserAvatar from '@/svg/user-avatar';
// Homepage
import LetterLine from '@/svg/letter-line';

export {
  CapterraLogoSVG,
  CrowdLogoSVG,
  GetAppLogoSVG,
  SoftwareAdviceLogoSVG,
  RatingStarsSVG,
  CheckmarkSVG,
  ArrowSVG,
  UserAvatar,
  LetterLine
};
